<template>
	<div class="ma-5 pa-5">
		<v-row>
			<v-col>
				<v-btn
					slot="actions"
					color="primary"
					@click="createQuestion({})"
				>
					הוספת שאלה
				</v-btn>
			</v-col>
		</v-row>
		<row>
			<c-col cols="6">
				<question-search
					:selected-questions="questions"
					@add="addQuestion"
					@edit="onEdit"
				/>
			</c-col>
			<c-col cols="6">
				<game-questions
					:questions="questions"
					@remove="removeQuestion"
					@reorder="reorderQuestions"
				/>
			</c-col>
		</row>
		<popup-dialog v-model="questionsModal">
			<span slot="header">יצירת שאלות</span>
			<question-form
				v-if="questionsModal"
				:from-game-menu="fromGameMenu"
				@save="addQuestion"
				@cancel="questionsModal = false"
			/>
		</popup-dialog>
	</div>
</template>

<script>
import QuestionSearch from "src/view/games/QuestionSearch";
import GameQuestions from "src/view/games/GameQuestions";
import { types as TypeGames } from "dev/store/modules/Game.module";
import { types as TypeGameQuestion } from "dev/store/modules/GameQuestion.module";
import { types } from "root/packages/closeapp/QuestionsManager/assets/store/Question.module";
import QuestionForm from "root/packages/closeapp/QuestionsManager/assets/views/questions/QuestionForm";

export default {
	name: "GameQuestionView",
	components: { QuestionForm, QuestionSearch, GameQuestions },
	data () {
		return {
			questionsModal: false,
			fromGameMenu: true,
		};
	},
	computed: {
		questions () {
			return this.$store.state.GameModule.game.questions || [];
		},
		game () {
			return this.$store.state.GameModule.game;
		},

	},
	created () {
		this.$store.dispatch(TypeGames.GET, this.$route.params.id);
	},
	methods: {
		async addQuestion (q) {
			this.questionsModal = false;
			await this.$store.dispatch(TypeGameQuestion.SAVE, {
				game_id: this.game.id,
				question_id: q.id,
				sort: this.latest() + 1,
			});
			this.$store.dispatch(TypeGames.GET, this.game.id);
		},
		async removeQuestion (q) {
			await this.$store.dispatch(TypeGameQuestion.REMOVE, q);
			this.$store.dispatch(TypeGames.GET, this.game.id);
		},
		async reorderQuestions (questions) {
			const originalQuestions = this.game.questions;
			const reorderedQuestions = questions.map((question, index) => {
				question.sort = index;
				return question;
			});
			this.updateQuestionLocally(reorderedQuestions);
			try {
				await this.$store.dispatch(TypeGameQuestion.REORDER, { gameId: this.game.id, questions: reorderedQuestions });
				await this.$store.dispatch(TypeGames.GET, this.game.id);
			} catch (e) {
				swal.fire({
					type: "error",
					title: "חלה שגיאה בעדכון השרת",
					text: "נא לנסות שוב מאוחר יותר",
				}).then(() => {
					this.updateQuestionLocally(originalQuestions);
				});
			}
		},
		createQuestion (question) {
			this.$store.commit(types.CREATE, question);
			this.questionsModal = true;
		},
		onEdit (question) {
			this.$store.commit(types.GET, question);
			this.questionsModal = true;
		},
		updateQuestionLocally (questions) {
			const gameClone = Object.assign({}, this.game);
			gameClone.questions = questions;
			this.$store.commit(TypeGames.GET, gameClone);
		},
		latest () {
			if (!this.questions.length) {
				return 0;
			}
			return Math.max(...this.questions.map((question) => question.sort));
		},
	},
};
</script>
